import { render, staticRenderFns } from "./FeatureDetailMarked.vue?vue&type=template&id=de75d6ea&scoped=true&"
import script from "./FeatureDetailMarked.vue?vue&type=script&lang=ts&"
export * from "./FeatureDetailMarked.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureDetailMarked.vue?vue&type=style&index=0&id=de75d6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de75d6ea",
  null
  
)

export default component.exports